import { render, staticRenderFns } from "./ChangeFilteringModule.vue?vue&type=template&id=2ffda4e9&"
import script from "./ChangeFilteringModule.vue?vue&type=script&lang=js&"
export * from "./ChangeFilteringModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports